import { createContext, useContext, useState } from "react";

export const translations = {
  fr: {
    nav: { about: "Qui sommes-nous", ports: "Destinations", routes: "Itinéraires", tracking: "Suivi", quote: "Devis", billing: "Facturation", contact: "Contact" },
    about: {
      overline: "Qui sommes-nous",
      title: "Sodimax Logistics, depuis 2014",
      text: "Créée en 2014 à Montréal, Sodimax Logistics est née d'une conviction : le corridor Canada — Afrique de l'Ouest et centrale mérite un spécialiste, pas un généraliste.",
      text2: "Depuis plus de dix ans, notre professionnalisme fait notre réputation : chaque conteneur est suivi, chaque document vérifié, chaque client rappelé. Nous traitons vos marchandises comme si elles étaient les nôtres.",
      points: [
        "Plus de 10 ans d'expérience en fret maritime international",
        "Équipe bilingue, disponible et joignable directement",
        "Agents partenaires dans les 7 ports africains desservis",
        "Transparence totale sur les coûts, les documents et les délais",
      ],
      since: "Année de création — Montréal",
    },
    hero: {
      overline: "Shipping & Transport International — Montréal · Toronto",
      lines: ["Du Canada", "vers l'Afrique de l'Ouest", "et centrale —", "en flux hebdomadaire."],
      sub: "Sodimax Logistics relie le Canada à l'Afrique de l'Ouest et centrale. Transport de conteneurs FCL & LCL au départ de Montréal et Toronto, vers sept ports stratégiques.",
      cta1: "Demander un devis",
      cta2: "Explorer les destinations",
      stats: [
        { value: "07", label: "Ports desservis" },
        { value: "02", label: "Hubs canadiens" },
        { value: "30j", label: "Transit le plus court" },
        { value: "65j", label: "Transit le plus long" },
      ],
      scroll: "Défiler",
    },
    marquee: "Montréal — Toronto — Abidjan — Dakar — Douala — Lomé — Matadi — Conakry — Port-Gentil — ",
    manifesto: {
      overline: "Notre manifeste",
      title: "Une seule route. Une seule exigence.",
      chapters: [
        { num: "01", title: "La route", text: "Nous avons choisi un corridor et nous le maîtrisons : le Saint-Laurent, l'Atlantique Nord, le golfe de Guinée. Pas de dispersion, une expertise profonde sur chaque escale." },
        { num: "02", title: "La précision", text: "Chaque conteneur est suivi, chaque transit est chronométré, chaque document est vérifié deux fois. La ponctualité n'est pas un objectif, c'est une discipline." },
        { num: "03", title: "La relation", text: "Derrière chaque boîte, il y a une entreprise qui attend. Nous répondons au téléphone, nous parlons français et anglais, et nous connaissons vos marchés." },
      ],
    },
    departures: {
      overline: "Ports de départ",
      title: "Deux gateways canadiens",
      ports: [
        { name: "Montréal", tag: "Hub principal — Saint-Laurent", text: "Départs hebdomadaires depuis le Port de Montréal. Accès direct au cœur industriel du Québec et de l'Ontario.", img: "montreal" },
        { name: "Toronto", tag: "Terminal intermodal", text: "Chargements depuis le Grand Toronto via notre terminal intermodal, acheminés par rail vers nos navires à Montréal.", img: "toronto" },
      ],
    },
    destinations: {
      overline: "Destinations",
      title: "Sept ports. Un corridor.",
      sub: "De l'Atlantique Nord au golfe de Guinée, nous desservons les principales portes d'entrée de l'Afrique de l'Ouest et centrale.",
      transit: "Transit dès",
      days: "jours",
      from: "au départ de Montréal",
    },
    calculator: {
      overline: "Calculateur d'itinéraire",
      title: "Estimez votre transit",
      origin: "Port de départ",
      destination: "Port de destination",
      result: {
        distance: "Distance nautique",
        km: "soit",
        transit: "Temps de transit estimé",
        days: "jours",
        eta: "Arrivée estimée si départ aujourd'hui",
        freq: "Départs hebdomadaires",
      },
      note: "Estimation indicative — le transit exact dépend du navire et de la saison.",
    },
    tracking: {
      overline: "Suivi de conteneur",
      title: "Où est votre boîte ?",
      placeholder: "Ex : BORU1234567",
      button: "Localiser",
      demo: "Données de démonstration",
      vessel: "Navire",
      route: "Route",
      eta: "ETA",
      progress: "Progression",
      tryHint: "Essayez n'importe quel numéro, ex : BORU1234567",
    },
    quote: {
      overline: "Demande de devis",
      title: "Parlons de votre cargaison",
      sub: "Réponse sous 24 h ouvrées, en français ou en anglais.",
      name: "Nom complet",
      company: "Entreprise",
      email: "Courriel",
      phone: "Téléphone",
      origin: "Port de départ",
      destination: "Port de destination",
      container: "Type de conteneur",
      quantity: "Quantité",
      message: "Détails de la cargaison",
      submit: "Envoyer la demande",
      sending: "Envoi…",
      success: "Demande envoyée — nous revenons vers vous sous 24 h.",
      error: "Erreur lors de l'envoi. Réessayez.",
      containers: ["20' Dry", "40' Dry", "40' High Cube", "40' Reefer"],
    },
    billing: {
      overline: "Facturation",
      title: "Transmission des factures",
      emailTitle: "Transmission des factures",
      emailText: "Envoyez vos factures et documents comptables à :",
      bankTitle: "Compte bancaire — paiement des factures",
      bankText: "Règlement par virement bancaire :",
      beneficiary: "Bénéficiaire",
      bank: "Banque",
      institution: "Institution",
      transit: "Transit",
      account: "Compte",
      swift: "SWIFT",
      currency: "Devise",
      note: "Mentionnez toujours votre numéro de connaissement (B/L) en référence du virement.",
      copy: "Copier",
      copied: "Copié",
      customize: "Coordonnées de démonstration — à personnaliser avec vos informations réelles.",
    },
    footer: {
      tagline: "Le corridor Canada — Afrique de l'Ouest, maîtrisé de bout en bout.",
      nav: "Navigation",
      contact: "Contact",
      legal: "© 2026 Sodimax Logistics Inc. Tous droits réservés.",
    },
    admin: {
      login: "Connexion admin",
      email: "Courriel",
      password: "Mot de passe",
      submit: "Se connecter",
      error: "Identifiants invalides",
      dashboard: "Demandes de devis",
      logout: "Déconnexion",
      total: "Total",
      new: "Nouveaux",
      status: { nouveau: "Nouveau", en_cours: "En cours", traite: "Traité" },
      empty: "Aucune demande pour le moment.",
    },
  },
  en: {
    nav: { about: "About us", ports: "Destinations", routes: "Routes", tracking: "Tracking", quote: "Quote", billing: "Billing", contact: "Contact" },
    about: {
      overline: "About us",
      title: "Sodimax Logistics, since 2014",
      text: "Founded in Montreal in 2014, Sodimax Logistics was born from a conviction: the Canada — West and Central Africa corridor deserves a specialist, not a generalist.",
      text2: "For over ten years, our professionalism has built our reputation: every container tracked, every document checked, every client called back. We handle your goods as if they were our own.",
      points: [
        "Over 10 years of international ocean freight experience",
        "Bilingual team, available and directly reachable",
        "Partner agents in all 7 African ports we serve",
        "Full transparency on costs, documents and lead times",
      ],
      since: "Year founded — Montreal",
    },
    hero: {
      overline: "Shipping & Transport International — Montreal · Toronto",
      lines: ["From Canada", "to West & Central", "Africa —", "weekly sailings."],
      sub: "Sodimax Logistics connects Canada to West and Central Africa. FCL & LCL container shipping from Montreal and Toronto to seven strategic ports.",
      cta1: "Request a quote",
      cta2: "Explore destinations",
      stats: [
        { value: "07", label: "Ports served" },
        { value: "02", label: "Canadian hubs" },
        { value: "30d", label: "Fastest transit" },
        { value: "65d", label: "Longest transit" },
      ],
      scroll: "Scroll",
    },
    marquee: "Montreal — Toronto — Abidjan — Dakar — Douala — Lomé — Matadi — Conakry — Port-Gentil — ",
    manifesto: {
      overline: "Our manifesto",
      title: "One route. One standard.",
      chapters: [
        { num: "01", title: "The route", text: "We chose one corridor and we master it: the St. Lawrence, the North Atlantic, the Gulf of Guinea. No dispersion — deep expertise on every call." },
        { num: "02", title: "Precision", text: "Every container is tracked, every transit is timed, every document is checked twice. Punctuality is not a goal, it is a discipline." },
        { num: "03", title: "Relationship", text: "Behind every box there is a business waiting. We answer the phone, we speak French and English, and we know your markets." },
      ],
    },
    departures: {
      overline: "Departure ports",
      title: "Two Canadian gateways",
      ports: [
        { name: "Montreal", tag: "Main hub — St. Lawrence", text: "Weekly sailings from the Port of Montreal. Direct access to the industrial heart of Quebec and Ontario.", img: "montreal" },
        { name: "Toronto", tag: "Intermodal terminal", text: "Loadings from the Greater Toronto Area via our intermodal terminal, railed to our vessels in Montreal.", img: "toronto" },
      ],
    },
    destinations: {
      overline: "Destinations",
      title: "Seven ports. One corridor.",
      sub: "From the North Atlantic to the Gulf of Guinea, we serve the main gateways of West and Central Africa.",
      transit: "Transit from",
      days: "days",
      from: "ex-Montreal",
    },
    calculator: {
      overline: "Route calculator",
      title: "Estimate your transit",
      origin: "Port of origin",
      destination: "Port of destination",
      result: {
        distance: "Nautical distance",
        km: "approx.",
        transit: "Estimated transit time",
        days: "days",
        eta: "Estimated arrival if sailing today",
        freq: "Weekly sailings",
      },
      note: "Indicative estimate — exact transit depends on vessel and season.",
    },
    tracking: {
      overline: "Container tracking",
      title: "Where is your box?",
      placeholder: "E.g. BORU1234567",
      button: "Track",
      demo: "Demo data",
      vessel: "Vessel",
      route: "Route",
      eta: "ETA",
      progress: "Progress",
      tryHint: "Try any number, e.g. BORU1234567",
    },
    quote: {
      overline: "Quote request",
      title: "Let's talk about your cargo",
      sub: "Reply within 24 business hours, in French or English.",
      name: "Full name",
      company: "Company",
      email: "Email",
      phone: "Phone",
      origin: "Port of origin",
      destination: "Port of destination",
      container: "Container type",
      quantity: "Quantity",
      message: "Cargo details",
      submit: "Send request",
      sending: "Sending…",
      success: "Request sent — we'll get back to you within 24h.",
      error: "Send failed. Please try again.",
      containers: ["20' Dry", "40' Dry", "40' High Cube", "40' Reefer"],
    },
    billing: {
      overline: "Billing",
      title: "Invoice submission",
      emailTitle: "Invoice submission",
      emailText: "Send your invoices and accounting documents to:",
      bankTitle: "Bank account — invoice payment",
      bankText: "Payment by wire transfer:",
      beneficiary: "Beneficiary",
      bank: "Bank",
      institution: "Institution",
      transit: "Transit",
      account: "Account",
      swift: "SWIFT",
      currency: "Currency",
      note: "Always quote your Bill of Lading (B/L) number as the transfer reference.",
      copy: "Copy",
      copied: "Copied",
      customize: "Demo details — to be replaced with your real information.",
    },
    footer: {
      tagline: "The Canada — West Africa corridor, mastered end to end.",
      nav: "Navigation",
      contact: "Contact",
      legal: "© 2026 Sodimax Logistics Inc. All rights reserved.",
    },
    admin: {
      login: "Admin login",
      email: "Email",
      password: "Password",
      submit: "Sign in",
      error: "Invalid credentials",
      dashboard: "Quote requests",
      logout: "Log out",
      total: "Total",
      new: "New",
      status: { nouveau: "New", en_cours: "In progress", traite: "Done" },
      empty: "No requests yet.",
    },
  },
};

const LangContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("fr");
  const t = (path) => path.split(".").reduce((o, k) => (o ? o[k] : undefined), translations[lang]) ?? path;
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
